import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceAjax, DceAjaxAction} from "dce-ajax";
import {data} from "jquery";

interface ToastsContainerProps {
}

/**
 * Globalny kontener toastów przychodzących z ajaxowych akcji
 */
@Dce("ToastsContainer")
export default class ToastsContainer extends DceComponent<ToastsContainerProps> implements DceAjaxAction{
    private _toastContainer: HTMLDivElement;

    constructor(elem: DceHTMLElement, props: ToastsContainerProps) {
        super(elem, props);
        DceAjax.getInstance().registerActionHandler("toast", this);
        this._toastContainer = document.createElement('div');
        this._toastContainer.classList.add('toast-container');

        elem.append(this._toastContainer);
    }

    execute(data: any): void {

        let toast = document.createElement('div');
        toast.classList.add('toast');
        toast.innerHTML = data;

        this._toastContainer.append(toast);

        setTimeout(() => { toast.classList.add('visible'); }, 100);
        setTimeout(() => { toast.classList.add('hiding'); }, 1500);
        setTimeout(() => { toast.remove(); } , 5000);

    }

    getPriority(): number {
        return 0;
    }

}